import { Table } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import OperationTableBody from "./OperationTableBody";
import { useAuth } from "context/AuthContext";
 
const OperationTable = ({operations}) =>{ 
    const { t } = useTranslation(['Warehouses']);
    const { auth } = useAuth();
    
    return (<> 
        <div className="crm-table-wrap">
            <Table className="WOperTable table-hover mt-3">
                <thead> 
                    <tr className="bg-light">
                        <td className="head-username">{t('fields.userName')}</td>
                        <td className="head-set">{t('fields.set')}</td>
                        <td className="head-date">{t('fields.date')}</td>
                        <td className="head-count">{t('fields.count')}</td>
                        {auth?.user?.access?.role == 'manager' && 
                            (<td className="head-price" title={t('labelPrice')}>{t('fields.price')}</td>)}
                        <td className="head-warehouse">{t('fields.warehouse')}</td>
                        <td className="head-description"></td>
                    </tr>
                </thead>
     
                <OperationTableBody
                    operations={operations}/>
            </Table>
        </div>

    </>)
}

export default OperationTable;